import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Features from "./components/Features";
import ProblemSolution from "./components/ProblemSolution";
import ProductCategories from "./components/ProductCategories";
import ComparisonTable from "./components/ComparisonTable";
import ArticlePreview from "./components/ArticlePreview";
import ArticleGrid from "./components/ArticleGrid";
import FAQ from "./components/FAQ";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Features />
        <ProblemSolution />
        <ProductCategories />
        <ComparisonTable />
        <ArticlePreview />
        <ArticleGrid />
        <FAQ />
        <Testimonials />
        <CTASection />
        {/* SEO Schema: Organization + WebSite + BreadcrumbList + FAQPage */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify([
              {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "USFans Spreadsheet",
                "url": import.meta.env.VITE_SITE_URL,
                "description": "Kompletny system zarządzania danymi dla twórców",
                "sameAs": []
              },
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "USFans Spreadsheet",
                "url": import.meta.env.VITE_SITE_URL,
                "description": "Kompletny system zarządzania danymi dla twórców — poradniki, szablony i porównania 2026",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": {
                    "@type": "EntryPoint",
                    "urlTemplate": import.meta.env.VITE_SITE_URL + "/?s={search_term_string}"
                  },
                  "query-input": "required name=search_term_string"
                }
              },
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Strona główna",
                    "item": import.meta.env.VITE_SITE_URL
                  }
                ]
              },
              {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "Czym jest USFans Spreadsheet?",
                    "acceptedAnswer": { "@type": "Answer", "text": "USFans Spreadsheet to zaawansowany system zarządzania danymi stworzony specjalnie dla twórców. Łączy w sobie funkcjonalność arkusza kalkulacyjnego z nowoczesnymi narzędziami do organizacji, śledzenia i automatyzacji danych." }
                  },
                  {
                    "@type": "Question",
                    "name": "Jak używać USFans Spreadsheet?",
                    "acceptedAnswer": { "@type": "Answer", "text": "Korzystanie z USFans Spreadsheet jest intuicyjne. Wystarczy zaimportować lub wprowadzić dane, wybrać odpowiedni szablon i zacząć organizować informacje. System oferuje gotowe szablony dla różnych scenariuszy." }
                  },
                  {
                    "@type": "Question",
                    "name": "Czy USFans Spreadsheet jest bezpieczny?",
                    "acceptedAnswer": { "@type": "Answer", "text": "Tak, USFans Spreadsheet spełnia wszystkie wymogi bezpieczeństwa, w tym zgodność z RODO (GDPR). Dane są szyfrowane podczas przesyłania i przechowywania, a system regularnie przechodzi audyty bezpieczeństwa." }
                  },
                  {
                    "@type": "Question",
                    "name": "Czy dostępny jest darmowy USFans Spreadsheet?",
                    "acceptedAnswer": { "@type": "Answer", "text": "Tak, oferujemy darmowe szablony i materiały, które pozwalają rozpocząć pracę z USFans Spreadsheet bez żadnych kosztów. Pełna wersja systemu oferuje dodatkowe funkcje." }
                  },
                  {
                    "@type": "Question",
                    "name": "Czym USFans Spreadsheet różni się od Excela?",
                    "acceptedAnswer": { "@type": "Answer", "text": "USFans Spreadsheet oferuje znacznie więcej niż tradycyjny Excel. Posiada wbudowane szablony dostosowane do potrzeb twórców, lepszą automatyzację, intuicyjny interfejs i zaawansowane funkcje śledzenia danych." }
                  }
                ]
              }
            ])
          }}
        />
      </main>
      <Footer />
    </>
  );
}